import { inject, Service } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SharePendingRequest } from '@portal-core/util/observables.decorators';
import { ApiService } from '@portal-core/auth/services/api.service';

@Service()
export class VersionApiService {
  private readonly http = inject(HttpClient);
  private readonly apiService = inject(ApiService);

  @SharePendingRequest()
  getVersionAndBuildDate$(): Observable<string> {
    return this.http.get<string>(`${this.apiService.centralApiBaseUri}/api/common/centralVersion`);
  }
}
